export const WALLET_ADDRESS = 'WALLET_ADDRESS';

export const WALLET_DATA = 'WALLET_DATA';

export const DEPLOYMENT_FEE_DATA = "DEPLOYMENT_FEE_DATA"
